export const socialMatchKeys = {
	all: ["social-match"] as const,
	status: (userId: number) =>
		[...socialMatchKeys.all, "status", userId] as const,
	searchCheck: (userId: number) =>
		[...socialMatchKeys.all, "search-check", userId] as const,
	action: (notificationId: number) =>
		[...socialMatchKeys.all, "action", notificationId] as const,
} as const
